module.exports = __webpack_public_path__ + "img/bill1.ea41df0a.jpg";